import React from 'react'
import { techs } from '../datas/photo'
import { revTechs } from '../datas/photo'
import "../Slider.css"

const Technology = () => {
    let tech =[];
    techs.forEach(function(item){
        tech.push(item)
    })
  return (
    <section className='Technology bg-bgFooter py-6'>
        <h1 className="text-center font-cavaet text-3xl sm:text-4xl md:text-5xl text-blue-600"> Techonlogies I've worked with <span></span> </h1>
        <hr className='w-40 sm:w-40 mx-auto md:w-80  pb-0.5 mb-6 bg-slate-400' />
        <div className="slider">

            <div className="slide-track">

                <div className="slide space-x-48">
                {
                    tech.map((image,i)=>(
                        <img className="w-max-full h-max-full"  src={image} alt="" />
                    ))
                }
                </div>
                <div className="slide space-x-48">
                {
                    revTechs.map((image,i)=>(
                        <img src={image} alt="" />
                    ))
                }
                </div>
            </div>
        </div>
    </section>
  )
}

export default Technology